import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppConfig } from '../app-config';
import { APP_CONFIG } from '../app-config.token';
import saveAs from 'file-saver';
import { map, Observable, tap } from 'rxjs';
import { ReportDto } from '../models/dtos/ReportDto';
import { IPagedResult } from '../shared/models/PagedResult';
import { ReportTypeEnum } from '../models/enums/report-type';
import { DictionaryItem } from '../models/dictionary-item';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  private readonly API_URL = this.config.resourceApiURI + '/reports';

  constructor() { }

  getReports(
    page: number,
    count: number,
    sortingField: string,
    sortingDirection: string = 'desc',
  ): Observable<IPagedResult<ReportDto>> {
    let params = new HttpParams()
      .set('page', `${page || 1}`)
      .set('count', `${count || 10}`)
      .set('sortingField', sortingField)
      .set('sortingDirection', sortingDirection);

    const url = `${this.API_URL}`;
    return this.http.get<IPagedResult<ReportDto>>(url, { params: params });
  }

  generateReport(reportType: ReportTypeEnum, additionalData: any = null): Observable<any> {
    const url = `${this.API_URL}/generate`;
    const body = {
      reportType: reportType,
      additionalData: additionalData
    };
    return this.http.post<any>(url, body);
  }

  getReport(id: number, fileName: string): Observable<any> {
    const url = this.API_URL + '/download/' + id;
    return this.http.get(url, { responseType: 'blob' }).pipe(tap((response) => saveAs(response, fileName + '.csv')));
  }

  deleteReport(id: number): Observable<any> {
    const url = this.API_URL + '/' + id;
    return this.http.delete<any>(url);
  }

  getAccessedReportTypes(): Observable<DictionaryItem[]> {
    const url = `${this.API_URL}/accessedReportTypes`;
    return this.http.get<DictionaryItem[]>(url);
  }
}
